import { z } from "zod";
import { DmaCalculationState } from "../dma-calculation-state";
import { dmaCalculationResultsDtoSchema } from "./dma-calculation-results.schema";
export const dmaSucceededCalculationStatusDtoSchema = z.object({
    state: z.literal(DmaCalculationState.Succeeded),
    jobStartedAt: z.string().datetime({ offset: true }),
    jobFinishedAt: z.string().datetime({ offset: true }),
    results: dmaCalculationResultsDtoSchema,
});
